import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import fetch from '../../utils/fetcher'
import useFetch from '../../utils/useFetch'
import { ModalManagerContext } from '../ModalsManager'
import PlotWrapper from '../common/PlotWrapper'
import PrimaryButton from '../common/buttons/PrimaryButton'
import Loading from '../common/icons/Loading'
import { SuccessMessage, ErrorMessage, useVisible } from '../common/AlertManager'
import QuestionBarChart from './QuestionBarChart'
import QuestionPieChart from './QuestionPieChart'
import QuestionRatingChart from './QuestionRatingChart'
import { getFormsUrl, getCampaignDownloadUrl } from './config'
import useStyles from './styles'


const FormsContainer = ({ campaignId, splitId }) => {
  const openModal = useContext(ModalManagerContext)
  const { render } = useFetch(getFormsUrl(splitId), openModal)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [successMessage, setSuccessMessage] = useState()
  const { visible: isErrorVisible, open: openError } = useVisible(false)
  const { visible: isSuccessMessageVisible, open: openSuccessMessage } = useVisible(false)
  const { t } = useTranslation(['translation'])
  const classes = useStyles()

  useEffect(() => {
    setSuccessMessage(null)
    setError(null)
  }, [campaignId])

  const download = async () => {
    setLoading(true)
    try {
      await fetch(getCampaignDownloadUrl(campaignId))
      setError(null)
      setSuccessMessage(t('QUESTIONNAIRE.DOWNLOAD_SUCCESS_MESSAGE'))
      openSuccessMessage()
    } catch (error) {
      setSuccessMessage(null)
      openError()
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  return render(({ data: formData }) => (
    <>
      <div className={classes.questionnaireContainer}>
        <PlotWrapper
          title={t('QUESTIONNAIRE.MULTIPLE_CHOICE_QUESTION')}
          overriddenClasses={{ plotWrapperTitle: classes.plotWrapperTitle }}
        >
          <QuestionBarChart data={formData.multiple} />
        </PlotWrapper>
        <PlotWrapper
          title={t('QUESTIONNAIRE.SINGLE_CHOICE_QUESTION')}
          overriddenClasses={{ plotWrapperTitle: classes.plotWrapperTitle }}
        >
          <QuestionPieChart data={formData.single} />
        </PlotWrapper>
        <PlotWrapper
          title={t('QUESTIONNAIRE.RATING_QUESTION')}
          overriddenClasses={{ plotWrapperTitle: classes.plotWrapperTitle }}
        >
          <QuestionRatingChart data={formData.rating} />
        </PlotWrapper>
      </div>
      <div className={classes.buttonContainer}>
        <h3 className={classes.downloadTitle}>
          {t('QUESTIONNAIRE.DOWNLOAD_TITLE')}
        </h3>
        <ErrorMessage error={error} visible={isErrorVisible} />
        {successMessage && <SuccessMessage message={successMessage} visible={isSuccessMessageVisible} />}
        {loading && <Loading />}
        <PrimaryButton
          type="submit"
          disabled={loading}
          className={classes.button}
          onClick={download}
        >
          {t('QUESTIONNAIRE.DOWNLOAD_BUTTON')}
        </PrimaryButton>
      </div>
    </>
  ))
}

FormsContainer.propTypes = {
  campaignId: PropTypes.string.isRequired,
  splitId: PropTypes.string.isRequired,
}

export default FormsContainer
